<template>
  <div class="cclone-graph-chart" style="width:100%; height:100%;">
    <v-chart
      class="w-chart--cclone"
      :option="chartData"
      style="height: 300px"
      @click="getPointFormula($event)"
    />
  </div>
</template>

<script>
// Avoid repeating namespace for each store action/mutation/getter/state
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex'

import { get } from 'lodash'

export default {
    name: 'CCloneChart',

    props: {
        ccloneData: { type: Array, required: true },
        selectedProfile: { type: String, required: true }
    },

    data() {
        return {
            options: {
                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    nameTextStyle: {
                        color: '#4d4d4d'
                    },
                    name: '% in database recency 1 day(s)',
                    nameLocation: 'center',
                    nameGap: 35,
                    min: 0,
                    max: 100,
                    interval: 5,
                    type: 'value',
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    nameTextStyle: {
                        color: '#4d4d4d'
                    },
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    name: 'Expected gain',
                    nameLocation: 'center',
                    nameRotate: 90,
                    nameGap: 30
                    // position: 'right'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        params = params[0]
                        const uniqueUsers = Math.round(params.value[0] * 100) / 100
                        const gain = Math.round(params.value[1] * 100) / 100
                        return 'Unique users: ' + uniqueUsers + '% | Gain: ' + gain + 'x'
                    },
                    axisPointer: {
                        label: {
                            show: true
                        }
                    }
                }
            }
        }
    },

    computed: {
        ...mapGetters('data/cclone', ['getCclonesCoordinates']),
        ...mapState('ui/cclone', { ccloneId: state => state.selectedCcloneId }),
        ...mapState('data/cclone', { ccloneDetails: state => state.ccloneDetails }),
        profile() {
            return this.selectedProfile === 'nonEmpty' ? 'nep' : 'ap'
        },
        selectedPoint() {
            return this.ccloneDetails[this.ccloneId].selectedPoint
        },
        chartData() {
            return {
                ...this.options,
                series: [
                    {
                        type: 'line',
                        data: this.getCclonesCoordinates({ ccloneData: this.ccloneData, selectedPoint: this.selectedPoint }),
                        smooth: true,
                        lineStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#f12711' // color at 0% position
                                    },
                                    {
                                        offset: 1,
                                        color: '#f5af19' // color at 100% position
                                    }
                                ],
                                global: false // false by default
                            },
                            width: 6
                        }
                    }
                ]
            }
        }
    },
    watch: {
        $route: {
            handler: function(newValue) {
                if (newValue.path !== '/' + this.accountId + '/builder/cclone') {
                    this.setSelectedPoint({ ccloneId: this.ccloneId, data: [] })
                    this.setCcloneFormula({ formula: null })
                }
            },
            deep: true
        }
    },

    methods: {
        ...mapState('account', { userRole: state => state.userRole }),
        ...mapMutations('ui/builder', ['setCcloneFormula']),
        ...mapMutations('data/cclone', ['setSelectedPoint', 'setDecisionTree', 'setSelectedPointLabel']),
        ...mapActions('data/cclone', ['retrieveDecisionTree']),
        ...mapActions('ui/builder', ['processStatistics']),
        getPointFormula(event) {
            if (this.selectedPoint[0] == event.data.value[0] && this.selectedPoint[1] == event.data.value[1]) {
                this.setSelectedPoint({ ccloneId: this.ccloneId, data: [] })
                this.setCcloneFormula({ formula: null })
            } else {
                this.setSelectedPoint({ ccloneId: this.ccloneId, data: event.data.value })
                this.setCcloneFormula({ formula: get(this.ccloneData, `${event.dataIndex}.formula`, null) })
                this.setDecisionTree({ status: null, image: null })
                this.retrieveDecisionTree({ id: this.ccloneId, rank: get(this.ccloneData, `${event.dataIndex}.rank`, null), profile: this.profile })
                if (this.userRole !== 'webo_admin') {
                    this.processStatistics({
                        formula: JSON.parse(get(this.ccloneData, `${event.dataIndex}.formula`, '{}')),
                        type: 'volumes',
                        version: 1,
                        from: 'cclone'
                    })
                }
            }
            this.getLabel()
        },
        getLabel() {
            const selectedPointUniqueUsers = this.selectedPoint[0]
            const selectedPointGain = this.selectedPoint[1]
            
            const uniqueUsers = Math.round(selectedPointUniqueUsers * 100) / 100
            const gain = Math.round(selectedPointGain * 100) / 100

            const label = 'Unique users: ' + uniqueUsers + '% | Gain: ' + gain + 'x'
            this.setSelectedPointLabel({ label: label })
        }
    }
}
</script>
